import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  padding: 2rem;
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  max-width: 800px;
  width: 100%;
`;

const BackLink = styled.button`
  display: block;
  margin: 0 auto 1.5rem;
  background: none;
  border: none;
  color: #666;
  font-size: 0.9rem;
  text-decoration: underline;

  &:hover {
    color: #e91e63;
  }
`;

const Title = styled.h2`
  color: #e91e63;
  margin-bottom: 2.5rem;
  text-align: center;
`;

const ModeGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;
  max-width: 440px;
  margin: 0 auto;
`;

const ModeButton = styled.button`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  text-align: left;
  gap: 0.45rem;
  padding: 1.1rem 1.15rem;
  border-radius: 8px;
  border: 1px solid #e91e63;
  cursor: pointer;
  transition: all 0.2s;
  background-color: ${({ $primary }) => ($primary ? '#e91e63' : 'white')};

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
    background-color: ${({ $primary }) => ($primary ? '#d81b60' : '#fff5f8')};
  }
`;

const ModeTitleRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 0.5rem;
`;

const ModeName = styled.span`
  font-weight: 600;
  font-size: 1.05rem;
  color: ${({ $primary }) => ($primary ? 'white' : '#e91e63')};
`;

const ModeTime = styled.span`
  font-size: 0.8rem;
  font-weight: 500;
  white-space: nowrap;
  color: ${({ $primary }) => ($primary ? 'rgba(255, 255, 255, 0.9)' : '#999')};
`;

const ModeDescription = styled.span`
  font-size: 0.95rem;
  line-height: 1.35;
  color: ${({ $primary }) => ($primary ? 'rgba(255, 255, 255, 0.92)' : '#666')};
`;

const ModeSelection = ({ gender, onFreePractice, onQuickPractice, onGameMode, onChangeGender }) => (
  <Container>
    {onChangeGender && (
      <BackLink onClick={onChangeGender}>
        &larr; Practicing with {gender === 'male' ? 'men' : 'women'}, change?
      </BackLink>
    )}
    <Title>Pick a mode to get started.</Title>
    <ModeGrid>
      <ModeButton onClick={onFreePractice}>
        <ModeTitleRow>
          <ModeName>Free Practice</ModeName>
          <ModeTime>10 min</ModeTime>
        </ModeTitleRow>
        <ModeDescription>
          Pick a personality, then chat at your own pace. Nudge their mood as you
          go.
        </ModeDescription>
      </ModeButton>

      <ModeButton onClick={onQuickPractice}>
        <ModeTitleRow>
          <ModeName>Quick Practice</ModeName>
          <ModeTime>5 min</ModeTime>
        </ModeTitleRow>
        <ModeDescription>
          A short warm-up with a <strong>random</strong> personality, for when you'd
          rather not choose.
        </ModeDescription>
      </ModeButton>

      <ModeButton $primary onClick={onGameMode}>
        <ModeTitleRow>
          <ModeName $primary>Date in Eight</ModeName>
          <ModeTime $primary>8 min</ModeTime>
        </ModeTitleRow>
        <ModeDescription $primary>
          The challenge: win a real date from a <strong>random</strong> personality
          before the clock hits zero.
        </ModeDescription>
      </ModeButton>
    </ModeGrid>
  </Container>
);

export default ModeSelection;
